export const usagePageChartCategoryConstants = {
    DAILY: 'DAILY',
    HOURLY: 'HOURLY',
    MONTHLY: 'MONTHLY'
}